import * as validations from '../../../../validations/validations';

import { FormInput } from '../../..';
import { FormInputModel } from '../../../../models';
import { HandleValueModel } from '../../../../models/component/HandleValueModel';
import React from 'react';
import { State } from 'stores/shared/NewStatefulFunction';
import objectHelper from '../../../../utils/ObjectHelper';
import { observer } from 'mobx-react';
import { useLocalization } from 'localization/LocalizationProvider';
import { useStore } from 'stores/MobXTypedStoreHook';

const SpaceMultiplierField = () => {
  const translate = useLocalization();
  const { artificialIntelligenceModel } = useStore(x => x.settingsStore);
  
  return <FormInput {...{
    translate,
    model: new FormInputModel({
      readonly: artificialIntelligenceModel.updateDefaultAIConstants.state === State.Processing,
      validationSchema: validations.getBasicNumberSchema(),
      placeholder: translate(x => x.forms.airdome.artificialIntelligence.spaceMultiplier),
      handleValueModel: new HandleValueModel({
        setValue: artificialIntelligenceModel.innerTemperatureAmplificationRegulation.setValue,
        inputType: 'number'
      }),
      label: translate(x => x.forms.airdome.artificialIntelligence.spaceMultiplier),
      inputId: 'AISpaceMultiplier',
      value: objectHelper.executeIfNumber(
        artificialIntelligenceModel.innerTemperatureAmplificationRegulation.Value,
        x => x.toString())
        || ''
    })
  }} />;
};

export default observer(SpaceMultiplierField);
